import React, { Component } from "react";
import Banner from "./Banner";
import BannerTabNav from "./BannerTabNav";
import Superoffers from "./Superoffers";
import Event from "./Events/Event";
import Footer from "./Footer";
import "./Header.css";
import { Link, Redirect, NavLink } from "react-router-dom";
import { Base64 } from "js-base64";
import {
  getGeoInfo,
  getCustomerLogin,
  getSpecialOffersForHome,
} from "./axios";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";
import Skeleton from "react-loading-skeleton";
import SkeletonHome from "./SkeletonHome";
import { useSelector, useDispatch } from 'react-redux';
import { connect } from 'react-redux';
import CartDropDown from "./Cart/CartDropDown";
import SliderComponent from "./SliderComponent";
import { countCartWithPackage } from "./AdminPackageDetails/PackageShowcase/commonFunction";
const TabsArr = [
  "Accommodations",
  "Attractions & Things to Do",
  "Packages",
  "Land & Ferry Transfers",
  "Liveaboard",
];


class Header extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);
    const { cookies } = props;
    this.state = {
      nav: false,
      selected: "Accommodations",
      country: "",
      country_code: "",
      currency: "",
      ip_address: "",
      customerEmail: cookies.get("userDetails") || "",
      customerEmailForData: localStorage.getItem("userDetails") || "abc",
      customerDetails: {},
      profileNew: false,
      profileNewAgain: false,
      cartProfile: false,
      cartProfileAgain: false,
      LoginEmail: "",
      LoginPassword: "",
      errorPassword: false,
      notActivePassword: false,
      OfferData: null,
      cartItemList:[],
      permissionArray: [],
      makebookingArray: ["make", "administrator"],
      cancelbookingArray: ["cancel", "administrator"],
    };
  }


  handleScroll = () => {
    if (window.pageYOffset > 40) {
      if (!this.state.nav) {
        this.setState({ nav: true });
      }
    } else {
      if (this.state.nav) {
        this.setState({ nav: false });
      }
    }
  };
  setSelectedTabOptions = (tab) => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    this.setState({ selected: tab });
  };

  

  componentDidMount() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const tabName = urlParams.get("t");

    if (tabName != null) {
      if (Base64.atob(tabName) == 1) {
        this.setState({ selected: "Accommodations" });
      } else if (Base64.atob(tabName) == 2) {
        this.setState({ selected: "Attractions & Things to Do" });
      } else if (Base64.atob(tabName) == 3) {
        this.setState({ selected: "Packages" });
      } else if (Base64.atob(tabName) == 4) {
        this.setState({ selected: "Land & Ferry Transfers" });
      } else if (Base64.atob(tabName) == 5) {
        this.setState({ selected: "Liveaboard" });
      }
    }

    let userData = localStorage.getItem("userDetails");
   
    getGeoInfo().then(
      (data) => {
      
        this.setState({ country: data.country_name });
        this.setState({ country_code: data.country_calling_code });
        this.setState({ currency: data.currency });
        this.setState({ ip_address: data.ip });
      },
      (error) => {}
    );

    if (userData != null) {
      const { cookies } = this.props;
      
      let newData = JSON.parse(userData);
      getCustomerLogin(newData.email).then(
        (data) => {
            // console.log(data);
             this.setState({ customerDetails: data });
             if(data?.user =='nouser'){
              let Verified = "";
              if (data.agent.verified == 1) {
                Verified = true;
              }
    
              const dataSearch = {
                first_name: data.agent.first_name,
                last_name: data.agent.last_name,
                email: data.agent.email,
                country_code: data.agent.country_code,
                verified: Verified,
                uid: data.agent.id,
                agent_id: data.agent.id,
                permissionArray: 'agent',
              };
    
              let JsonData = JSON.stringify(dataSearch);
    
              localStorage.setItem("userDetails", JsonData);
             }else{
             
              let Verified = true;
              let  permissionArray = null;
              if (data?.user?.permission) {
                permissionArray = data?.user?.permission.split(",");
              } 
            
              const dataSearch = {
                first_name: data.user.user_first_name,
                last_name: data.user.user_last_name,
                email: data.user.user_email,
                country_code: data.user.country_code,
                verified: Verified,
                uid: data.user.user_id,
                agent_id: data.agent.id,
                permissionArray: permissionArray,
              };
    
              let JsonData = JSON.stringify(dataSearch);
    
              localStorage.setItem("userDetails", JsonData);

              if (data?.user?.permission) {
                const permissionArrayData = data?.user?.permission.split(",");
                this.setState({ permissionArray: permissionArrayData});
              } 
 
             }

        },
        (error) => {}
      );
    }

    getSpecialOffersForHome().then(
      (data) => {
       
        this.setState({ OfferData: data });
      },
      (error) => {}
    );

    window.addEventListener("scroll", this.handleScroll);
  }


  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("click", this.globalClickListener);
  }

  globalClickListener = (nativeEvent) => {
    this.setState({ profileNew: false, profileNewAgain: false, cartProfile:false, cartProfileAgain:false }, () => {
    
      window.removeEventListener("click", this.globalClickListener);
    });
  };
  OpenProfilelink = (syntheticEvent) => {
   
    syntheticEvent.stopPropagation();
    this.setState(
      (prevState) => ({ profileNew: !prevState.profileNew }),
      () => {
        if (this.state.profileNew) {
        
          window.addEventListener("click", this.globalClickListener);
        }
      }
    );
    
  };
  OpenProfilelinkAgain = (syntheticEvent) => {
    
    syntheticEvent.stopPropagation();
    this.setState(
      (prevState) => ({ profileNewAgain: !prevState.profileNewAgain }),
      () => {
        if (this.state.profileNewAgain) {
         
          window.addEventListener("click", this.globalClickListener);
        }
      }
    );
   
  };

  OpenCartProfilelink = (syntheticEvent) => {
   
    syntheticEvent.stopPropagation();
    this.setState(
      (prevState) => ({ cartProfile: !prevState.cartProfile }),
      () => {
        if (this.state.cartProfile) {
          window.addEventListener("click", this.globalClickListener);
        }
      }
    );
   
  };

  OpenCartProfilelinkAgain = (syntheticEvent) => {
   
    syntheticEvent.stopPropagation();
    this.setState(
      (prevState) => ({ cartProfileAgain: !prevState.cartProfileAgain }),
      () => {
        if (this.state.cartProfileAgain) {
          window.addEventListener("click", this.globalClickListener);
        }
      }
    );
    
  };

  logoutChange = () => {
    localStorage.clear();
 //  window.location.reload(true);
   var base_url = window.location.origin;
   window.location.href = base_url;
  };

  
  render() {
    //console.log(this.state.permissionArray);
    return (
      <div id="page" className="bgGradient">
        <div className='mobile-menu'>
                <nav className="navbar navbar-expand-md navbar-light mobile-menu">
<button className="ma5menu__toggle" type="button">
<span class="ma5menu__icon-toggle"></span> <span class="ma5menu__sr-only">Menu</span>
</button>
<div>
<ul className="site-menu" style={{display: 'none'}}>
<li><a href="" title="Home">Home</a></li>
<li><a href="contact-us.html" title="Contact Us">Contact Us</a></li>
</ul>
</div>
</nav>
                </div>
        <div className="">
          <div className="container">
              <div className="row">
                  <div className="col-md-3 col-lg-3 col-sm-12 col-xs-12">
                       <div className="logo">
                       <a className="">
                <img
                  src="images/logo/seyLogo.png"
                  alt="Holiday Seychelles"
                />
              </a>
                       </div>
                  
                  </div>

                  
                  <div className="col-md-9 col-lg-9 col-sm-12 col-xs-12">
                     <div className="menu-top">
                     <ul className="float-left">
                {this.state.customerEmailForData == "abc" ? (
                  <li
                    className="hsFlex_Bann hsCenter hsMyTrips"
                    onClick={this.openModal}
                  >
                    <span className="landingSprite myTripsIcon appendRight10">
                      &nbsp;
                    </span>
                    <div className="hsFlex_Bann column flexOne font10 latoBold">
                      <p className="hs-white appendBottom3_Header">My Trips</p>
                    </div>
                  </li>
                ) : (
                  this.state.customerDetails?.user =='nouser' ?(
                  <Link to="/PlanTrips" target="_blank">
                    <li className="hsFlex_Bann hsCenter hsMyTrips">
                      <span className="landingSprite myTripsIcon appendRight10">
                        &nbsp;
                      </span>
                      <div className="hsFlex_Bann column flexOne font10 latoBold">
                        <p className="hs-white appendBottom3_Header">
                        My Bookings
                        </p>
                      </div>
                    </li>
                  </Link>
                  ):(<></>)
                )}
                <Link to="/tourofferlisting" target="_blank">
                  <li className="hsFlex_Bann hsCenter hsSupport">
                    <span className="landingSprite supportIcon appendRight10">
                      &nbsp;
                    </span>
                    <div className="hsFlex_Bann column flexOne font10 latoBold">
                      <p className="hs-white appendBottom3_Header">Offers</p>
                    </div>
                  </li>
                </Link>
                <Link to="/travelblog" target="_blank">
                  <li className="hsFlex_Bann hsCenter hsSupport">
                    <img 
                     src="images/airplane.png"
                     className=" travel_blog appendRight10"/>
                    <div className="hsFlex_Bann column flexOne font10 latoBold">
                      <p className="hs-white appendBottom3_Header">
                        Travel Blog
                      </p>
                    </div>
                  </li>
                </Link>
               

                {this.state.customerEmailForData == "abc" ? (
                  <li
                    className="hsFlex_Bann hsCenter font10 hsRelative hsUser full-with"
                    onClick={this.openModal}
                  >
                    <div className="hsFlex_Bann column flexOne hs-white latoBold">
                      <p className="hs-white appendBottom3_Header">
                        {" "}
                        <img
                          src="images/icon/favicon.ico"
                          className="loginIcon"
                        />{" "}
                        Login or Create Account
                      </p>
                    </div>
                  </li>
                ) : (
                  <li
                    className="hs-LoginFlex hsCenter font10 hsRelative hsUser userLoggedIn"
                    onClick={this.OpenProfilelink}
                  >
                    {this.state.customerDetails == {} ? (
                      <span>
                        <Skeleton style={{ width: 200, height: 20 }} />
                      </span>
                    ) : (
                      <>
                        {this.state.customerDetails?.agent?.profile_pic == "" ? (
                          <span className="userNameIcon hs-white hs-LoginFlex perfectCenter latoBlack appendRight10">
                            <span>
                              {this.state.customerDetails?.user =='nouser' ?(this.state.customerDetails?.agent?.first_name.charAt(0)):(this.state.customerDetails?.user?.user_first_name.charAt(0))}
                            </span>
                          </span>
                        ) : (
                          <span className="userNameImage  appendRight10">
                            <img
                              style={{ width: "100%", borderRadius: "100%" }}
                              src={this.state.customerDetails?.agent?.profile_pic}
                            />
                          </span>
                        )}

                        <div className="hs-LoginFlex column userNameText  hs-white latoBold">
                          <p
                            data-cy="loggedInUser"
                            className="appendBottom3 truncate customerName"
                          >
                            Hey {this.state.customerDetails?.user =='nouser' ?(this.state.customerDetails?.agent?.first_name):(this.state.customerDetails?.user?.user_first_name)}
                          </p>
                        </div>
                      </>
                    )}

                    {this.state.profileNew && (
                      this.state.customerDetails?.user =='nouser' ?(
                      <div className="userDropdown fadeInDown hs-LoginFlex column">
                        <a
                          className="userItems hs-LoginFlex"
                          href="/PlanTrips"
                        >
                          <span className="landingSprite userItemMyTrips appendRight20"></span>
                          <div>
                            <p className="font16 latoBold blackText appendBottom5">
                            My Bookings
                            </p>
                            <p className="font12 lineHeight16 blackText">
                              See booking details, planned your own trip, Cancel
                              Booking &amp; more.
                            </p>
                          </div>
                        </a>
                        <a
                          className="userItems hs-LoginFlex"
                          href="/mytripplan"
                        >
                          <span className="landingSprite userItemMyTrips appendRight20"></span>
                          <div>
                            <p className="font16 latoBold blackText appendBottom5">
                           My Trip Plan
                            </p>
                            
                          </div>
                        </a>
                      
                        <a
                          className="userItems hs-LoginFlex"
                          href="/Profile"
                        >
                          <span className="landingSprite userItemMyProfile appendRight20"></span>
                          <div>
                            <p className="font16 latoBold blackText appendBottom5 hs-LoginFlex hsCenter">
                              My Profile
                            </p>
                            <p className="font12 lineHeight16 blackText">
                              Manage your profile, login details and password
                            </p>
                          </div>
                        </a>
                       
                        <a
                          className="userItems hs-LoginFlex"
                          href="/subagentview"
                        >
                          <span className="landingSprite userItemMyTrips appendRight20"></span>
                          <div>
                            <p className="font16 latoBold blackText appendBottom5">
                           My Sub Agents
                            </p>
                           
                          </div>
                        </a>
                        <a
                          className="userItems hs-LoginFlex"
                          href="/agentuser"
                        >
                          <span className="landingSprite userItemMyTrips appendRight20"></span>
                          <div>
                            <p className="font16 latoBold blackText appendBottom5">
                           My Users
                            </p>
                            
                          </div>
                        </a>
                        <a
                          className="userItems hs-LoginFlex appendBottom10"
                          onClick={this.logoutChange}
                        >
                          <span className="landingSprite userItemLogout appendRight20"></span>
                          <div>
                            <p className="font16 latoBold blackText appendBottom5 hs-LoginFlex hsCenter">
                              Logout
                            </p>
                          </div>
                        </a>
                      </div>
                      ):(
                      <div className="userDropdown fadeInDown hs-LoginFlex column">
                        <a
                          className="userItems hs-LoginFlex"
                          href="/PlanTrips"
                        >
                          <span className="landingSprite userItemMyTrips appendRight20"></span>
                          <div>
                            <p className="font16 latoBold blackText appendBottom5">
                            My Bookings
                            </p>
                            <p className="font12 lineHeight16 blackText">
                              See booking details, planned your own trip, Cancel
                              Booking &amp; more.
                            </p>
                          </div>
                        </a>
                        {this.state.makebookingArray.some(value => this.state.permissionArray.includes(value))&&( 
                        <a
                          className="userItems hs-LoginFlex"
                          href="/mytripplan"
                        >
                          <span className="landingSprite userItemMyTrips appendRight20"></span>
                          <div>
                            <p className="font16 latoBold blackText appendBottom5">
                           My Trip Plan
                            </p>
                            
                          </div>
                        </a>
                        )}
                        <a
                          className="userItems hs-LoginFlex"
                          href="/Profileuser"
                        >
                          <span className="landingSprite userItemMyProfile appendRight20"></span>
                          <div>
                            <p className="font16 latoBold blackText appendBottom5 hs-LoginFlex hsCenter">
                              My Profile
                            </p>
                            <p className="font12 lineHeight16 blackText">
                              Manage your profile
                            </p>
                          </div>
                        </a>
                        {this.state.permissionArray.includes("administrator") &&(
                        <a
                          className="userItems hs-LoginFlex"
                          href="/subagentview"
                        >
                          <span className="landingSprite userItemMyTrips appendRight20"></span>
                          <div>
                            <p className="font16 latoBold blackText appendBottom5">
                           My Sub Agents
                            </p>
                           
                          </div>
                        </a>
                        )}
                        {this.state.permissionArray.includes("administrator") &&( <a
                          className="userItems hs-LoginFlex"
                          href="/agentuser"
                        >
                          <span className="landingSprite userItemMyTrips appendRight20"></span>
                          <div>
                            <p className="font16 latoBold blackText appendBottom5">
                           My Users
                            </p>
                            
                          </div>
                        </a>)}
                       
                        <a
                          className="userItems hs-LoginFlex appendBottom10"
                          onClick={this.logoutChange}
                        >
                          <span className="landingSprite userItemLogout appendRight20"></span>
                          <div>
                            <p className="font16 latoBold blackText appendBottom5 hs-LoginFlex hsCenter">
                              Logout
                            </p>
                          </div>
                        </a>
                      </div>)
                    )}
                  </li>

                )}

              
                  <li className="hsFlex_Bann hsCenter hsSupport">
                        <div className="hsFlex_Bann column flexOne font10 latoBold"  onClick={this.OpenCartProfilelink}>
                          <p className="appendBottom3_Header">
                            {" "}
                            <a href="javascript:void(0)" class="cart position-relative d-inline-flex" aria-label="View your shopping cart">
                                <img src="images/cart/ecommerce.png" className=" travel_blog appendRight10"/> 
                                <span class="cart-basket d-flex align-items-center justify-content-center">
                                {countCartWithPackage(this.props.showcart.cardItems.cardData)}
                                </span>
                              </a>
                          </p>
                        </div>
                        {this.state.cartProfile && (
                        <CartDropDown showcart={this.props.showcart.cardItems.cardData}></CartDropDown>
                           )}

                      
                      </li>
               
              </ul>
                     </div>
                  </div>
              </div>

            <div className="hsFlex_Bann hsCenter prependTop5 appendBottom15 mobile-view"> </div>

            <div className="header-top-section">
              <div
                className={`chHeaderWrapper ${
                  this.state.nav == true ? " stickyHeader" : " navOnly"
                }`}
              >
                <div className="chHeaderContainer">
                  <span className="logoContainer">
                    <a className="chMmtLogo" href="/home">
                      <img
                        src="images/logo/seyLogo.png"
                        alt="Holiday Seychelles"
                        
                      />
                    </a>
                  </span>

                  <BannerTabNav
                    tabs={TabsArr}
                    selected={this.state.selected}
                    setSelectedTab={this.setSelectedTabOptions}
                  ></BannerTabNav>

                  <ul className="userSection pushRight">
                    
                    {this.state.customerEmailForData == "abc" ? (
                      <li
                        className="hsFlex_Bann hsCenter font10 hsRelative hsUser"
                        onClick={this.openModal}
                      >
                        <div className="hsFlex_Bann column flexOne latoBold">
                          <p className="appendBottom3_Header">
                            {" "}
                            <img
                              src="images/icon/favicon.ico"
                              className="loginIcon"
                            />{" "}
                            Login or Create Account
                          </p>
                        </div>
                      </li>
                    ) : (
                      <li
                        className="hs-LoginFlex hsCenter font10 hsRelative hsUser userLoggedIn"
                        onClick={this.OpenProfilelinkAgain}
                      >
                        {this.state.customerDetails?.agent?.profile_pic == "" ? (
                          <span className="userNameIcon hs-white hs-LoginFlex perfectCenter latoBlack appendRight10">
                            <span>
                             
                              {this.state.customerDetails?.user =='nouser' ?(this.state.customerDetails?.agent?.first_name.charAt(0)):(this.state.customerDetails?.user?.user_first_name.charAt(0))}
                            </span>
                          </span>
                        ) : (
                          <span className="userNameImage  appendRight10">
                            <img
                              style={{ width: "100%", borderRadius: "100%" }}
                              src={this.state.customerDetails?.agent?.profile_pic}
                            />
                          </span>
                        )}

                        <div className="hs-LoginFlex column userNameText  latoBold">
                          <p
                            data-cy="loggedInUser"
                            className="appendBottom3 truncate customerName"
                          >
                            Hey {this.state.customerDetails?.user =='nouser' ?(this.state.customerDetails?.agent?.first_name):(this.state.customerDetails?.user?.user_first_name)}
                          </p>
                        </div>
                        {this.state.profileNewAgain && (
                          this.state.customerDetails?.user =='nouser' ?(
                          <div className="userDropdown fadeInDown hs-LoginFlex column dropbanner">
                            <a
                              className="userItems hs-LoginFlex"
                              href="/PlanTrips">
                              <span className="landingSprite userItemMyTrips appendRight20"></span>
                              <div>
                                <p className="font16 latoBold blackText appendBottom5">
                                My Bookings
                                </p>
                                <p className="font12 lineHeight16 blackText">
                                  See booking details, planned your own trip,
                                  Cancel Booking &amp; more.
                                </p>
                              </div>
                            </a>
                            <a
                              className="userItems hs-LoginFlex"
                              href="/mytripplan">
                              <span className="landingSprite userItemMyTrips appendRight20"></span>
                              <div>
                                <p className="font16 latoBold blackText appendBottom5">
                                My Trip Plan
                                </p>
                               
                              </div>
                            </a>

                            <a
                              className="userItems hs-LoginFlex"
                              href="/Profile">
                              <span className="landingSprite userItemMyProfile appendRight20"></span>
                              <div>
                                <p className="font16 latoBold blackText appendBottom5 hs-LoginFlex hsCenter">
                                  My Profile
                                </p>
                                <p className="font12 lineHeight16 blackText">
                                  Manage your profile, login details and
                                  password
                                </p>
                              </div>
                            </a>
                            <a
                              className="userItems hs-LoginFlex"
                              href="/subagentview"
                            >
                              <span className="landingSprite userItemMyTrips appendRight20"></span>
                              <div>
                                <p className="font16 latoBold blackText appendBottom5">
                                My Sub Agents
                                </p>
                                <p className="font12 lineHeight16 blackText">
                                 
                                </p>
                              </div>
                            </a>
                            <a
                              className="userItems hs-LoginFlex"
                              href="/agentuser"
                            >
                              <span className="landingSprite userItemMyTrips appendRight20"></span>
                              <div>
                                <p className="font16 latoBold blackText appendBottom5">
                                My Users
                                </p>
                                <p className="font12 lineHeight16 blackText">
                                 
                                </p>
                              </div>
                            </a>
                            <a
                              className="userItems hs-LoginFlex appendBottom10"
                              onClick={this.logoutChange}
                            >
                              <span className="landingSprite userItemLogout appendRight20"></span>
                              <div>
                                <p className="font16 latoBold blackText appendBottom5 hs-LoginFlex hsCenter">
                                  Logout
                                </p>
                              </div>
                            </a>
                          </div>
                          ):(<div className="userDropdown fadeInDown hs-LoginFlex column dropbanner">
                          <a
                            className="userItems hs-LoginFlex"
                            href="/PlanTrips">
                            <span className="landingSprite userItemMyTrips appendRight20"></span>
                            <div>
                              <p className="font16 latoBold blackText appendBottom5">
                              My Bookings
                              </p>
                              <p className="font12 lineHeight16 blackText">
                                See booking details, planned your own trip,
                                Cancel Booking &amp; more.
                              </p>
                            </div>
                          </a>
                          {this.state.makebookingArray.some(value => this.state.permissionArray.includes(value))&&(
                          <a
                              className="userItems hs-LoginFlex"
                              href="/mytripplan">
                              <span className="landingSprite userItemMyTrips appendRight20"></span>
                              <div>
                                <p className="font16 latoBold blackText appendBottom5">
                                My Trip Plan
                                </p>
                               
                              </div>
                            </a>)}
                         <a
                            className="userItems hs-LoginFlex"
                            href="/Profileuser">
                            <span className="landingSprite userItemMyProfile appendRight20"></span>
                            <div>
                              <p className="font16 latoBold blackText appendBottom5 hs-LoginFlex hsCenter">
                                My Profile
                              </p>
                              <p className="font12 lineHeight16 blackText">
                                Manage your profile
                              </p>
                            </div>
                          </a>
                          {this.state.permissionArray.includes("administrator") &&( 
                          <a
                            className="userItems hs-LoginFlex"
                            href="/subagentview"
                          >
                            <span className="landingSprite userItemMyTrips appendRight20"></span>
                            <div>
                              <p className="font16 latoBold blackText appendBottom5">
                              My Sub Agents
                              </p>
                              <p className="font12 lineHeight16 blackText">
                               
                              </p>
                            </div>
                          </a>
                          )}
                          {this.state.permissionArray.includes("administrator") &&( 
                          <a
                            className="userItems hs-LoginFlex"
                            href="/agentuser"
                          >
                            <span className="landingSprite userItemMyTrips appendRight20"></span>
                            <div>
                              <p className="font16 latoBold blackText appendBottom5">
                              My Users
                              </p>
                              <p className="font12 lineHeight16 blackText">
                               
                              </p>
                            </div>
                          </a>)}
                          <a
                            className="userItems hs-LoginFlex appendBottom10"
                            onClick={this.logoutChange}
                          >
                            <span className="landingSprite userItemLogout appendRight20"></span>
                            <div>
                              <p className="font16 latoBold blackText appendBottom5 hs-LoginFlex hsCenter">
                                Logout
                              </p>
                            </div>
                          </a>
                        </div>)
                        )}
                      </li>
                    )}

                  <li
                        className="hsFlex_Bann hsCenter font10 hsRelative">
                        <div className="hsFlex_Bann column flexOne latoBold"  onClick={this.OpenCartProfilelinkAgain}>
                          <p className="appendBottom3_Header">
                            {" "}
                            <a href="javascript:void(0)" class="cart position-relative d-inline-flex" aria-label="View your shopping cart">
                                <img src="images/cart/ecommerce.png" className=" travel_blog appendRight10"/> 
                                <span class="cart-basket d-flex align-items-center justify-content-center">
                                {countCartWithPackage(this.props.showcart.cardItems.cardData)}
                                </span>
                              </a>
                          </p>
                        </div>
                        {this.state.cartProfileAgain && (
                        <CartDropDown showcart={this.props.showcart.cardItems.cardData}></CartDropDown>
                           )}

                      
                      </li>
                  </ul>
                </div>
              </div>
            </div>

            <Banner isSelected={this.state.selected} />
            <Link to="/enterDetails">
              <button id="mobileSearchBtn">Search</button>
            </Link>
          </div>
          
        </div>

        <SliderComponent heading="Packages" />
        {this.state.OfferData == null ? (
          <>
            {" "}
            <SkeletonHome />{" "}
          </>
        ) : (
          <>
            <Superoffers OfferData={this.state.OfferData} />
            {/* <Event />
            <Footer
              showNews={"News"}
              tabs={TabsArr}
              selected={this.state.selected}
              setSelectedTab={this.setSelectedTabOptions}
            />{" "} */}
          </>
        )}
            <Event />
            <Footer
              showNews={"News"}
              tabs={TabsArr}
              selected={this.state.selected}
              setSelectedTab={this.setSelectedTabOptions}
            />

      </div>
    );
  }
}

const mapDispatchToProps= (dispatch)=>{
}
const mapStateToProps = (state, ownProps = {}) => {
  return{
      showcart:state
  }
}

export default connect(mapStateToProps, mapDispatchToProps) (withCookies(Header));
